var _path, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 99,
    viewBox: "0 0 83 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.728 53.1584H20.448L30.3168 69.1328V53.1584H37.1136V80H30.432L20.5248 63.9872V80H13.728V53.1584ZM54.2484 80.576C51.5348 80.576 49.0772 79.9872 46.8756 78.8096C44.6996 77.632 42.9716 75.9936 41.6916 73.8944C40.4372 71.7696 39.81 69.3376 39.81 66.5984C39.81 63.8592 40.4372 61.4272 41.6916 59.3024C42.9716 57.1776 44.6996 55.5264 46.8756 54.3488C49.0772 53.1712 51.5348 52.5824 54.2484 52.5824C56.9364 52.5824 59.3684 53.1712 61.5444 54.3488C63.746 55.5264 65.474 57.1776 66.7284 59.3024C67.9828 61.4272 68.61 63.8592 68.61 66.5984C68.61 69.3376 67.9828 71.7696 66.7284 73.8944C65.474 75.9936 63.746 77.632 61.5444 78.8096C59.3684 79.9872 56.9364 80.576 54.2484 80.576ZM54.2484 74.2016C55.6052 74.2016 56.8468 73.8944 57.9732 73.28C59.0996 72.6656 59.9956 71.7824 60.6612 70.6304C61.3268 69.4784 61.6596 68.1344 61.6596 66.5984C61.6596 65.0624 61.3268 63.7312 60.6612 62.6048C60.0212 61.4528 59.138 60.5696 58.0116 59.9552C56.8852 59.3152 55.6308 58.9952 54.2484 58.9952C52.8404 58.9952 51.5732 59.3152 50.4468 59.9552C49.3204 60.5696 48.4244 61.4528 47.7588 62.6048C47.1188 63.7312 46.7988 65.0624 46.7988 66.5984C46.7988 68.1344 47.1188 69.4784 47.7588 70.6304C48.4244 71.7824 49.3204 72.6656 50.4468 73.28C51.5988 73.8944 52.866 74.2016 54.2484 74.2016ZM70.5225 83.5712C72.8009 81.984 74.3497 80.832 75.1689 80.1152C75.9881 79.424 76.3977 78.784 76.3977 78.1952C76.3977 77.8112 76.2569 77.5296 75.9753 77.3504C75.7193 77.1712 75.3097 77.0816 74.7465 77.0816C74.1065 77.0816 73.4409 77.1968 72.7497 77.4272C72.0585 77.6576 71.4697 77.952 70.9833 78.3104V74.3552C71.4953 74.0224 72.2249 73.7408 73.1721 73.5104C74.1193 73.28 75.0281 73.1648 75.8985 73.1648C77.6905 73.1648 79.0473 73.5744 79.9689 74.3936C80.9161 75.1872 81.3897 76.1856 81.3897 77.3888C81.3897 78.3616 81.0697 79.2192 80.4297 79.9616C79.8153 80.6784 78.7273 81.6128 77.1657 82.7648H81.6201V86.1824H70.5225V83.5712Z",
    fill: "url(#paint0_linear_197_4130)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_4130",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "url(#paint1_linear_197_4130)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_4130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6668 66.6663C16.6113 66.6663 12.2918 64.9163 8.7085 61.4163C5.12516 57.9163 3.3335 53.6386 3.3335 48.583C3.3335 44.2497 4.63905 40.3886 7.25016 36.9997C9.86127 33.6108 13.2779 31.4441 17.5002 30.4997C18.8891 25.3886 21.6668 21.2497 25.8335 18.083C30.0002 14.9163 34.7224 13.333 40.0002 13.333C46.5002 13.333 52.0141 15.5969 56.5418 20.1247C61.0696 24.6525 63.3335 30.1663 63.3335 36.6663C67.1668 37.1108 70.3474 38.7636 72.8752 41.6247C75.4029 44.4858 76.6668 47.833 76.6668 51.6663C76.6668 55.833 75.2085 59.3747 72.2918 62.2913C69.3752 65.208 65.8335 66.6663 61.6668 66.6663H21.6668ZM21.6668 59.9997H61.6668C64.0002 59.9997 65.9724 59.1941 67.5835 57.583C69.1946 55.9719 70.0002 53.9997 70.0002 51.6663C70.0002 49.333 69.1946 47.3608 67.5835 45.7497C65.9724 44.1386 64.0002 43.333 61.6668 43.333H56.6668V36.6663C56.6668 32.0552 55.0418 28.1247 51.7918 24.8747C48.5418 21.6247 44.6113 19.9997 40.0002 19.9997C35.3891 19.9997 31.4585 21.6247 28.2085 24.8747C24.9585 28.1247 23.3335 32.0552 23.3335 36.6663H21.6668C18.4446 36.6663 15.6946 37.8052 13.4168 40.083C11.1391 42.3608 10.0002 45.1108 10.0002 48.333C10.0002 51.5552 11.1391 54.3052 13.4168 56.583C15.6946 58.8608 18.4446 59.9997 21.6668 59.9997Z",
    fill: "url(#paint2_linear_197_4130)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_4130",
    x1: 12,
    y1: 41,
    x2: 95.8446,
    y2: 64.9962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_4130",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#643B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9175A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_197_4130",
    x1: 40.0002,
    y1: 13.333,
    x2: 40.0002,
    y2: 74.6663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#643B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9175A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo2);
export default __webpack_public_path__ + "static/media/NO2.d06d21b18fd1e54d14928e483917a507.svg";
export { ForwardRef as ReactComponent };